// @ts-nocheck
import React, { useEffect, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridPaginationModel,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import dayjs from "dayjs";
import { createBooleanOperator, Loading, StatusBar, Table, } from "../../../components";
import { useUserInfo } from "../../../store/User.state";
import {
  useAuthorization,
  useGetMerchantStatusList,
  //  useUpdateAnnulmentQueryViewStatus,
  useGetMerchantCurrentBalances,
} from "../../../hooks";
import { useSetSnackBar } from '../../../store/Snackbar.state';
import { downloadExcel } from "../../../util/downloadExcel";
import { mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType, RequestFilterValueTypeEnums } from '../../../common/enums/RequestFilterEnums';
import { FamilyRestroom } from "@mui/icons-material";
import { flattenDiagnosticMessageText } from "typescript";
import { Tooltip } from "@mui/material";

interface QueryOptions {
  field?: string;
  value?: any;
  [key: string]: any;
}

interface RequestPayload {
  size: number;
  page: number;
  orderBy: string;
  orderByDesc: boolean;
  merchantId: string | null;
  [key: string]: any;
}

interface PagingResponse<T> {
  result: T;
  totalItems: number;
  pageSize: number;
  page: number;
}

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;
  return <>{value && <StatusBar status={value} />}</>;
}

const booleanOptions = [
  { label: "Aktif", value: 1 },
  { label: "Pasif", value: 2 },
];


export const CurrentBalanceListFilter = () => {
  const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [requestPayload, setRequestPayload] = useState<RequestPayload>({
    size: paginationModel.pageSize,
    page: paginationModel.page, // Backend 1-based pagination kullanıyorsa
    orderBy: "CreateDate",
    orderByDesc: true,
  });
  const {
    data: getMerchantCurrentBalances,
    mutateAsync: getMerchantCurrentBalancesAsync,
    isLoading,
  } = useGetMerchantCurrentBalances();
  const setSnackbar = useSetSnackBar();
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});
  // const { mutateAsync: updateViewStatus } = useUpdateAnnulmentQueryViewStatus();
  const [dynamicFilters, setDynamicFilter] = useState<any[]>([]);

  useEffect(() => {
    if (getMerchantCurrentBalances?.data) {
      setTableData({
        result: getMerchantCurrentBalances.data.result || [],
        totalItems: getMerchantCurrentBalances.data.totalItems || 0,
        pageSize: requestPayload.size,
        page: requestPayload.page - 1, // MUI DataGrid 0-based pagination kullanıyor
      });
    }
  }, [getMerchantCurrentBalances, requestPayload]);

  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantState: { value: string; key: number }) => {
        return {
          label: merchantState.key,
          value: `${merchantState.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  useEffect(() => {
    const savedFilter = localStorage.getItem("currentBalanceFilterKey");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel({ page: model.page, pageSize: model.pageSize });
  };


  const [openModal, setOpenModal] = useState(null);

  /*   const handleViewStatusUpdate = async (params: any) => {
      try {
        await updateViewStatus({ id: params.id, viewStatus: !params.viewStatus });
        getMerchantCurrentBalancesAsync(requestPayload);
        setOpenModal(null);
      } catch (error) {
        console.error("View status update failed:", error);
      }
    }; */

  useEffect(() => {
    console.log('openModal', openModal)
  }, [openModal])

  const previousQueryParams = React.useRef({});

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "merchantId",
        headerName: "İşyeri Id",
        width: 200,
      },
      {
        field: "merchantName",
        headerName: "İşyeri Adı",
        width: 250,
      },
      {
        field: "currency",
        headerName: "Para Birimi",
        width: 250,
      },
      {
        field: "debt",
        headerName: "Borç",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "credit",
        headerName: "Alacak",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "debtBalance",
        headerName: "Borç Bakiyesi",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "creditBalance",
        headerName: "Alacak Bakiyesi",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "isUserGoldBindingActive",
        headerName: "Altın Bağlantısı Aktif Mi?",
        width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        filterOperators: [createBooleanOperator(booleanOptions)],
        renderCell: (params) => {
          const isDisabled = params.row.currencyCode != "949";
          return (
            <Tooltip
              title={isDisabled ? 'Altın Bağlantı özelliği yalnızca TL hesapları için geçerlidir' : ''}
              arrow
              placement="top"
            >
              <div style={{
                cursor: isDisabled ? 'not-allowed' : 'default',
                opacity: isDisabled ? 0.5 : 1
              }}>
                {params.value && !isDisabled ? "Aktif" : "Pasif"}
              </div>
            </Tooltip>
          );
        }
      },
      {
        field: "totalGoldBinding",
        headerName: "Toplam Altın Bağlantısı",
        width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        renderCell: (params) => {
          const isDisabled = params.row.currencyCode != "949";
          return (
            <Tooltip
              title={isDisabled ? 'Altın Bağlantı özelliği yalnızca TL hesapları için geçerlidir' : ''}
              arrow
              placement="top"
            >
              <div style={{
                cursor: isDisabled ? 'not-allowed' : 'default',
                opacity: isDisabled ? 0.5 : 1
              }}>
                {params.value != null
                  ? parseFloat(params.value).toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) : "0,00"} TL
              </div>
            </Tooltip>
          );
        }
      },
    ];
  }, [showDelete, showUpdate, openModal]);

  const onSave = async () => {
    try {
      let excelRequestPayload = {
        size: tableData?.totalItems ?? 99,
        page: 0,
        orderBy: "CreateDate",
        orderByDesc: true,
        merchantId: userInfo?.merchantId !== "0" ? String(userInfo?.merchantId) ?? null : null,
        filters: [
          ...dynamicFilters
        ] // Handle dynamic filters
      };
      const response = await getMerchantCurrentBalancesAsync(excelRequestPayload);
      // Response path'ini doğru şekilde kontrol edelim
      const resultData = response?.data?.result;

      if (response?.isSuccess && resultData?.length > 0) {
        const mappedData = resultData.map((item: any) => ({
          "İşyeri Id": item?.merchantId,
          "İşyeri Adı": item?.merchantName,
          "Para Birimi": item?.currency,
          "Borç": item?.debt,
          "Alacak": item?.credit,
          "Borç Bakiyesi": item?.debtBalance,
          "Alacak Bakiyesi": item?.creditBalance,
          'Altın Bağlantısı Aktif Mi?': item?.isUserGoldBindingActive ? "Aktif" : "Pasif",
          'Toplam Altın Bağlantısı': item?.totalGoldBinding
        }));

        if (mappedData.length > 0) {
          downloadExcel(mappedData, "Cari Bakiye Listesi");
        } else {
          setSnackbar({
            severity: "warning",
            description: "İndirilecek veri bulunamadı",
            isOpen: true,
          });
        }
      } else {
        setSnackbar({
          severity: "error",
          description: "Dışa aktarma işlemi başarısız oldu",
          isOpen: true,
        });
      }
    } catch (error) {
      console.error("Export error:", error);
      setSnackbar({
        severity: "error",
        description: "İşlem sırasında bir hata oluştu",
        isOpen: true,
      });
    }
  };

  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: unknown[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  const decimalFields = ['totalAmount', 'amount', 'totalComission'];

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      if (value === "false") {
        queryParams[key] = false;
      }
      else if (key === 'isUserGoldBindingActive') {
        queryParams[key] = value === 2 ? 0 : 1;
      }
      else if (value !== null && value !== undefined && value.toString().length > 0) {
        if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
          queryParams[key] = Number(parseFloat(value).toFixed(2));
        } else {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };

  const convertTableFiltersToRequestFilter = (tableFilters) => {

    let convertedFilters = [];

    tableFilters.items.map((item) => {

      var findColumn = columns.find(x => x.field == item.field);

      if (item.field === 'isUserGoldBindingActive') {
        // Preserve the original value in the filter dropdown
        convertedFilters.push({
          field: item.field,
          values: [item.value === 2 ? "0" : "1"],
          valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
          operationType: mapReactMUIToFilterOperationTypes(item.operator)
        });
      } else {
        convertedFilters.push({
          field: item.field,
          values: [item.value.toString()],
          valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
          operationType: mapReactMUIToFilterOperationTypes(item.operator)
        });
      }
    });

    return convertedFilters;
  }
  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      setRequestPayload({
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        merchantId: userInfo?.merchantId !== "0" ? String(userInfo?.merchantId) ?? null : null,
        filters: []
      });
      setQueryOptions({});
      localStorage.removeItem('currentBalanceFilterKey')
      return null;
    }

    const queryParams = getQueryParams(filters);
    const isValueValid = (key, value) => {
      if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission' || key === 'isUserGoldBindingActive') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }
    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
      debugger
      localStorage.setItem('currentBalanceFilterKey', JSON.stringify(queryParams));
    }

    previousQueryParams.current = queryParams;

  }, 500);


  // Ana useEffect - tüm değişiklikleri buradan yönetiyoruz
  useEffect(() => {
    const newPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: userInfo?.merchantId !== "0" ? String(userInfo?.merchantId) ?? null : null,
      filters: [
        ...dynamicFilters
      ] // Handle dynamic filters
    };
    getMerchantCurrentBalancesAsync(newPayload);
  }, [paginationModel, queryOptions, userInfo?.merchantId, dynamicFilters,]);

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

  return (
    <>
      {isLoading && <Loading />}
      <Stack flex={1} p={2}>
        <>
          <Table
            columnVisibilityConfigKey="currentBalanceFilterKeyTableColumnVisibilityKey"
            filterKey="currentBalanceFilterKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems ?? 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            // disableColumnMenu
            getRowId={() => { return Math.random(100000) }}
            rows={tableData?.result ?? []}
            columns={columns}
            exportFileName="Cari Bakiye Listesi"
            getRowClassName={(params: any) => {
              if (params?.row?.status === "PASSIVE") return "pasive-row";
              if (params?.row?.status === "BLOCKED") return "blocked-row";
              return "";
            }}
            onSave={() => onSave()}
          />
        </>
      </Stack>
    </>
  );
};

